export const CUSTOM_CHECKBOX_ID = 'CheckboxCustom'
